import React from 'react';
import PropTypes from 'prop-types';

export default function IconFloatTelegram({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6424 9.55225C12.0389 7.42822 12.8182 2.82031 12.9988 0.924316C13.0105 0.756348 12.9861 0.540039 12.9988 0.468262C12.9861 0.37207 12.95 0.240234 12.8309 0.144043C12.6863 0.0239258 12.4588 0 12.3621 0C11.906 0 11.2225 0.240234 7.88652 1.63232C6.72245 2.1123 4.39433 3.12012 0.890422 4.64404C0.526164 4.7915 0.271281 4.93408 0.130656 5.07471C0.053508 5.15186 0.0105393 5.22803 0.00272676 5.3042C-0.0451248 5.72412 0.542766 5.85596 1.29863 6.09619C1.91093 6.30029 2.72636 6.52832 3.158 6.54004C3.54277 6.55225 3.97441 6.38428 4.45487 6.06006C6.47734 4.69678 7.89237 3.74951 8.7039 3.21924C9.20585 2.89062 9.47734 2.72168 9.51835 2.7124L9.54667 2.70801C9.62284 2.69629 9.70585 2.68262 9.7703 2.73633C9.79765 2.76465 9.81718 2.79932 9.82695 2.83691C9.83769 2.87451 9.83866 2.91406 9.83085 2.95215C9.783 3.15137 7.84941 4.94385 6.95585 5.77246C6.71952 5.99121 6.55546 6.14258 6.51835 6.18018C6.42655 6.27393 6.3328 6.36279 6.24198 6.44873C5.66288 6.99902 5.22636 7.41357 6.25468 8.08838C6.76054 8.42188 7.16288 8.69629 7.56913 8.97314C7.98222 9.25391 8.39823 9.5376 8.93046 9.88818C9.06523 9.97705 9.19413 10.0688 9.32011 10.1587C9.82109 10.5156 10.2703 10.8359 10.8269 10.7881C11.1385 10.752 11.4744 10.4521 11.6424 9.55225Z"
        fill={color}
      />
    </svg>
  );
}

IconFloatTelegram.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
